

interface LiscenseCardProps {
  state: string
}

const LiscenseCard = (props: LiscenseCardProps) => {
  let content: JSX.Element = <div></div>
  switch (props.state.toLowerCase()) {
    case 'ontario':
      content = (
        <div sx={{ px: 2, py: 3 }}>
          <p sx={{ fontWeight: 'bold', mb: 3 }}>
            Maximum Allowable Cost per $100 Borrowed:
            <br />
            $15.00
          </p>
          <p sx={{ fontWeight: 'bold', mb: 3 }}>
            Our cost per $100 borrowed:
            <br />
            $15.00
          </p>
          <p sx={{ mb: 3 }}>
            Example: Your $500 loan for 14 days
            <br />
            Amount Advanced $500.00
            <br />
            Total Cost of Borrowing $75.00 (391.07% APR)
            <br />
          </p>
          <p>
            <em>This poster is required under the Payday Loans Act, 2008.</em>
          </p>
        </div>
      )
      break
    case 'british columbia':
      content = (
        <div sx={{ mx: '10px', p: '10px', border: 'solid 5px purple' }}>
          <div>
            <p sx={{ mb: 3 }}>Understanding the Cost of a Payday Loan</p>
            <p sx={{ fontWeight: 'bold', mb: 3 }}>
              Maximum charges permitted in British Columbia for a Payday{' '}
              <span>Loan 15% of Principal</span>
            </p>
            <p sx={{ mb: 3 }}>
              We charge $15 per $100 borrowed
              <br />
              For a $300 loan for 14 days:
              <br />
              Total cost of borrowing = $45
              <br />
              Annual Percentage Rate = 391.07%
              <br />
            </p>

            <p>
              This information meets the requirements of the{' '}
              <em>Business Practices and Consumer Protection Act</em>
            </p>
          </div>
        </div>
      )
      break
    case 'manitoba':
      content = (
        <div>
          <div>
            <h4>Payday Loans are High-Cost Loans</h4>
            <p>
              In Manitoba, the maximum allowable charge for a payday loan is 17%
              of the principal amount of the loan.
            </p>

            <p>
              <strong>Sample $300 loan for 12 days:</strong>
              <br />
              Total cost of credit = $51
              <br />
              The Annual Percentage Rate (APR) = 517.08%
              <br />
              ------------------------------------------------------------------------
              <br />
              The total that must be repaid is: $351.00
            </p>

            <p>
              This information meets the requirements of{' '}
              <em>The Consumer Protection Act</em>. To learn more about your
              rights as a payday loan borrower, contact the The Consumer
              Protection Office at 945-3800, 1-800-782-0067 or at{' '}
              <a
                href="http://www.gov.mb.ca/cca/cpo/"
                title="Consumer Protection Office"
                target="_blank"
                rel="noreferrer noopener"
              >
                http://www.gov.mb.ca/cca/cpo/
              </a>
              .
            </p>
            <p>Business Licence #39184</p>
          </div>
        </div>
      )
      break
    case 'nova scotia':
      content = (
        <div>
          <div>
            <h4>Payday Loans are High-Cost Loans</h4>
            <p>Example:</p>
            <p>$300.00 loan for 14 days</p>
            <table>
              <tbody>
                <tr>
                  <td>Principal amount</td>
                  <td>=</td>
                  <td>$300.00</td>
                </tr>
                <tr>
                  <td>Total cost of borrower</td>
                  <td>=</td>
                  <td>
                    <span>$57.00</span>
                  </td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    ------------------------------------------------------------
                  </td>
                </tr>
                <tr>
                  <td>Total to Repay</td>
                  <td>=</td>
                  <td>$300.00</td>
                </tr>
                <tr>
                  <td></td>
                  <td>PLUS</td>
                  <td>$57.00</td>
                </tr>
                <tr>
                  <td></td>
                  <td>=</td>
                  <td>$357.00</td>
                </tr>
              </tbody>
            </table>
            <p>Annual percentage rate APR = 495.36%</p>
            <br />
            <p>
              This information meets the requirements of the{' '}
              <em>
                Payday Loans Regulations under the Consumer Protection Act
              </em>
            </p>
          </div>
        </div>
      )
      break
    case 'sasketchewan':
      content = (
        <div>
          <div>
            <div>
              <h4>$17 per $100 borrowed</h4>
              <p>Example: $300 for 14 days</p>
              <table>
                <tbody>
                  <tr>
                    <td>Principal amount</td>
                    <td>&nbsp;</td>
                    <td>$300</td>
                  </tr>
                  <tr>
                    <td>Total cost of borrowing</td>
                    <td>&nbsp;</td>
                    <td>$51</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>&nbsp;</td>
                    <td>-----</td>
                  </tr>
                  <tr>
                    <td>Total to Pay</td>
                    <td>&nbsp;</td>
                    <td>$351</td>
                  </tr>
                </tbody>
              </table>
              <br />
              <p>
                <b>Fees and Charges:</b>
                <br />
                If you obtain a payday loan from us, you will pay the following
                fees and charges:
              </p>
              <ul>
                <li>
                  Loan Fee of 17% of the loan principal, payable on the loan
                  repayment date
                </li>
                <li>
                  NSF Charge of $25, for a dishonoured cheque or pre-authorized
                  debit. This charge is payable only once per loan, regardless
                  of the number of cheques or pre-authorized debits dishonoured
                </li>
                <li>
                  Default Interest of 30% per annum for the first 90 days and
                  then 26% thereafter, will be charged on the outstanding
                  principal balance of the loan, if you fail to pay the loan in
                  full on the repayment date.
                </li>
                <li>
                  This information conforms to the requirements of the{' '}
                  <span>Payday Loans Act</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )
      break
    case 'alberta':
      content = <p>Click Next to continue.</p>
      break
    default:
      content = <p>Click Next to continue.</p>
      break
  }

  return (
    <div
      sx={{
        bg: '#f4f4f4',
        borderRadius: '10px',
        border: 'solid 1px',
        borderColor: 'gray',
        py: '10px',
      }}
    >
      {content}
    </div>
  )
}

export default LiscenseCard
